import http from '../_http'

const partner = {
  //default
  summary : (m) => { return http.get(`manager/billing/invoice/partner/summary`, m); },
  listPartner: (m) => { return http.post(`manager/billing/invoice/partner/list`, m); },
  detailPartner: (m) => { return http.get(`manager/billing/invoice/partner/${m.id}`); },


  //crud
  insertPartner: (m) => { return http.post(`manager/billing/invoice/partner`, m); },
  updatePartner: (m) => { return http.put(`manager/billing/invoice/partner`, m); },
  deletePartner: (m) => { return http.delete(`manager/billing/invoice/partner/${m.id}`); },

  //ticket
  ticketPartner: (m) => { return http.post(`manager/billing/invoice/partner/ticket`, m); },
}

export default partner

export { partner }